import * as React from 'react'
import { useTooltipContext } from '@shared/ui/Overlays/Tooltip/hooks'
import { useMergeRefs } from '@floating-ui/react'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'

const TooltipTrigger = React.forwardRef<HTMLElement, React.HTMLProps<HTMLElement> & { asChild?: boolean }>(
  function TooltipTrigger({ children, asChild = false, ...props }, propRef) {
    const context = useTooltipContext()
    const childrenRef = (children as any).ref
    const ref = useMergeRefs([context.refs.setReference, propRef, childrenRef])

    // `asChild` allows the user to pass any element as the anchor
    if (asChild && React.isValidElement(children)) {
      const childElement = children as React.ReactElement<Record<string, unknown>>
      const childProps = childElement.props
      const referenceProps = context.getReferenceProps({
        ref,
        ...props,
        ...childProps,
      })

      return React.cloneElement(childElement, {
        ...referenceProps,
        'data-state': context.open ? 'open' : 'closed',
      })
    }

    return (
      <BlockBoundary>
        <button
          ref={ref}
          // The user can style the trigger based on the state
          data-state={context.open ? 'open' : 'closed'}
          {...context.getReferenceProps(props)}>
          {children}
        </button>
      </BlockBoundary>
    )
  },
)

export default TooltipTrigger
